import {
  Dialog,
  DialogActions,
  DialogContent,
  dialogClasses,
  styled,
} from '@mui/material';

export const DialogExportRouteRoadmapContainer = styled(Dialog)({
  [`&.${dialogClasses.paper}`]: {
    width: '100%',
  },
});

export const DialogExportRouteRoadmapContent = styled(DialogContent)(
  ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  }),
);

export const DialogExportRouteRoadmapActions = styled(DialogActions)({
  justifyContent: 'space-between',
});

export const DialogExportRouteRoadmapListItemIconImage = styled('img')({
  width: 80,
  marginLeft: 10,
  marginRight: 20,
});
